"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("D:\\G\\YT\\mes-project-web\\node_modules\\core-js\\modules\\es.array.iterator.js");
require("D:\\G\\YT\\mes-project-web\\node_modules\\core-js\\modules\\es.promise.js");
require("D:\\G\\YT\\mes-project-web\\node_modules\\core-js\\modules\\es.object.assign.js");
require("D:\\G\\YT\\mes-project-web\\node_modules\\core-js\\modules\\es.promise.finally.js");
var _vue = _interopRequireDefault(require("vue"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
require("normalize.css/normalize.css");
var _elementUi = _interopRequireDefault(require("element-ui"));
require("./assets/styles/element-variables.scss");
require("@/assets/styles/index.scss");
require("@/assets/styles/style.scss");
var _App = _interopRequireDefault(require("./App"));
var _store = _interopRequireDefault(require("./store"));
var _router = _interopRequireDefault(require("./router"));
var _permission = _interopRequireDefault(require("./directive/permission"));
var _DatamapBasic = _interopRequireDefault(require("./store/DatamapBasic"));
var _dataView = _interopRequireDefault(require("@jiaminghi/data-view"));
require("./assets/icons");
require("./permission");
var _data = require("@/api/system/dict/data");
var _config = require("@/api/system/config");
var _utils = require("@/utils/utils");
require("@/utils/directives");
var _permission3 = require("@/utils/permission");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _vueAmap = _interopRequireDefault(require("vue-amap"));
var _IcePopSelector = _interopRequireDefault(require("@/components/IcePopSelector/IcePopSelector"));
require("@assets/styles/wl-stylus/index.styl");
var _wlUtils = _interopRequireDefault(require("@utils/wl-utils"));
var _wlComponentGallery = _interopRequireDefault(require("@components/wl-component-gallery"));
var _SimpleFlow = _interopRequireDefault(require("@components/SimpleFlow"));
// a modern alternative to CSS resets
/* 图标库 */
// // import '@/assets/icons/wl-icons/demo.css'
// import '@/assets/icons/wl-icons/iconfont.css'
// import '@/assets/icons/wl-icons/iconfont.js'

// 引入组件
// import '@/assets/styles/wl-stylus.styl' // global css
// global css

_vue.default.use(_dataView.default);

// icon
// permission control

// 弹出对话框
/* wl stylus、utils、components */
// global css

Object.keys(_wlUtils.default).forEach(function (key) {
  return _vue.default.prototype["$$".concat(key)] = _wlUtils.default[key];
});
_vue.default.use(_wlComponentGallery.default);
_vue.default.component('IcePopSelector', _IcePopSelector.default);

// 全局方法挂载
_vue.default.prototype.getDicts = _data.getDicts;
_vue.default.prototype.getConfigKey = _config.getConfigKey;
_vue.default.prototype.parseTime = _utils.parseTime;
_vue.default.prototype.resetForm = _utils.resetForm;
_vue.default.prototype.addDateRange = _utils.addDateRange;
_vue.default.prototype.selectDictLabel = _utils.selectDictLabel;
_vue.default.prototype.download = _utils.download;
_vue.default.prototype.handleTree = _utils.handleTree;
_vue.default.prototype.hasPermi = _permission3.hasPermi;
_vue.default.prototype.$downFile = _utils.downFile;
_vue.default.prototype.$debounce = _utils.debounce;
_vue.default.prototype.msgSuccess = function (msg) {
  this.$message({
    showClose: true,
    message: msg,
    type: 'success'
  });
};
_vue.default.prototype.msgError = function (msg) {
  this.$message({
    showClose: true,
    message: msg,
    type: 'error'
  });
};
_vue.default.prototype.msgInfo = function (msg) {
  this.$message.info(msg);
};

// 全局组件挂载
_vue.default.component('Pagination', _Pagination.default);
_vue.default.use(_permission.default);
_vue.default.use(_SimpleFlow.default, {
  notRegisterNodeContent: false,
  // 如果需要自己编写节点内容组件，设为true
  notRegisterNodeTypeContent: false // 如果需要自己编写添加节点的悬浮面板组件，设为true
});

// 数据字典处理
_vue.default.mixin(_DatamapBasic.default);

// 高得地图注册
_vueAmap.default.initAMapApiLoader({
  key: '1db0c5015ae1eb52d9ccdde2c2b78759',
  plugin: ['AMap.Autocomplete',
  // 输入提示插件
  'AMap.PlaceSearch',
  // POI搜索插件
  'AMap.Scale',
  // 右下角缩略图插件 比例尺
  'AMap.OverView',
  // 地图鹰眼插件
  'AMap.ToolBar',
  // 地图工具条
  'AMap.MapType',
  // 类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
  'AMap.PolyEditor',
  // 编辑 折线多，边形
  'AMap.CircleEditor',
  // 圆形编辑器插件
  'AMap.Geolocation',
  // 定位控件，用来获取和展示用户主机所在的经纬度位置
  'AMap.TruckDriving' // 路径规划
  ],
  v: '1.4.13'
});
_vue.default.use(_vueAmap.default);

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online! ! !
 */

_vue.default.use(_elementUi.default, {
  size: _jsCookie.default.get('size') || 'medium' // set element-ui default size
});
_vue.default.config.productionTip = false;

// Vue.config.silent = true
// console.error = () => {}
// console.warn = () => {}
// console.log = () => {}
// eslint-disable-next-line no-new
new _vue.default({
  el: '#app',
  router: _router.default,
  store: _store.default,
  // beforeCreate中模板未解析，且this是vm
  beforeCreate: function beforeCreate() {
    _vue.default.prototype.$bus = this; // 安装全局事件总线
  },
  render: function render(h) {
    return h(_App.default);
  }
});